import { get } from './get-operacion-wrc'
import { put } from './put-operacion-wrc'
import { post } from './post-operacion-wrc'
import { putFirma } from '../../../api/put-firma'
import { getDetalles } from './get-detalles'
import { postDetalle } from './post-detalle'
import { getTipos } from './get-tipos'
import { getExcepcionesPorTipo } from './get-excepciones-por-tipo'
import { deleteOperationDetail } from './delete-detail'
import { descargarInforme } from './descargar-informe'

export const getEndpoint = (url = ''): string => `operaciones/wrc/${url}`
export const getEndpointCache = (url = ''): string => `cache/operaciones/wrc/${url}`

export const HttpWRC = {
    get: get,
    put: put,
    post: post,
    getDetalles: getDetalles,
    deleteOperationDetail: deleteOperationDetail,
    postDetalle: postDetalle,
    getTipos: getTipos,
    getExcepcionesPorTipo: getExcepcionesPorTipo,
    descargarInforme: descargarInforme,
} as const
